import type { ReactNode } from 'react';
import { BrandSparkle } from '@/components/brand/ornaments';
import { TypographyOverline } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

interface SectionKickerProps {
  children: ReactNode;
  className?: string;
  overlineClassName?: string;
  sparkleClassName?: string;
  withLines?: boolean;
}

export function SectionKicker({
  children,
  className,
  overlineClassName,
  sparkleClassName,
  withLines = false,
}: SectionKickerProps) {
  return (
    <div
      className={cn('mx-auto flex items-center justify-center gap-2 text-brand-gold', className)}
    >
      {withLines ? <span className="h-px w-10 bg-brand-gold/60 sm:w-20" aria-hidden /> : null}
      <BrandSparkle className={cn('h-3.5 w-3.5 shrink-0', sparkleClassName)} />
      <TypographyOverline className={overlineClassName}>{children}</TypographyOverline>
      <BrandSparkle className={cn('h-3.5 w-3.5 shrink-0', sparkleClassName)} />
      {withLines ? <span className="h-px w-10 bg-brand-gold/60 sm:w-20" aria-hidden /> : null}
    </div>
  );
}
